export const MailOutlineIcon = ({ color = "#4E4E4E", size = 20, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    {...props}
  >
    <g clip-path="url(#clip0_13076_6811)">
      <path d="M17.167 3.33301H3.83366C2.91699 3.33301 2.17533 4.08301 2.17533 4.99967L2.16699 14.9997C2.16699 15.9163 2.91699 16.6663 3.83366 16.6663H17.167C18.0837 16.6663 18.8337 15.9163 18.8337 14.9997V4.99967C18.8337 4.08301 18.0837 3.33301 17.167 3.33301ZM17.167 14.9997H3.83366V6.66634L10.5003 10.833L17.167 6.66634V14.9997ZM10.5003 9.16634L3.83366 4.99967H17.167L10.5003 9.16634Z"
        fill={color} />
    </g>
    <defs>
      <clipPath id="clip0_13076_6811">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
